type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

/**
 * Filled lightbulb glyph. Used to mark "Pro Tip" / "Did you know" affordances
 * so a reader can spot guidance copy without parsing the heading.
 */
const LightbulbIcon = (props: Props) => {
  const { width = '12', height = '12', fillColor = 'currentColor' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        d="M8 1.333A4.667 4.667 0 0 0 5.067 9.64c.39.31.6.79.6 1.293v.4h4.666v-.4c0-.504.21-.984.6-1.293A4.667 4.667 0 0 0 8 1.333Z"
        fill={fillColor}
      />
      <path
        d="M6 12.667h4M6.667 14h2.666"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LightbulbIcon;
